import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AdvertisingPlatformInfoForm} from './advertising-platform-info-form';

export class MetaAdsInfoForm extends AdvertisingPlatformInfoForm {

  constructor() {
    super();
    this.formGroup = new FormGroup({
      currencyId: new FormControl('', Validators.required),
      accountId: new FormControl('', Validators.required)
    });
  }

  static override getPlatformName(): string {
    return 'meta-ads';
  }
}
